/*eslint-disable */

let $ = window.jQuery;

$(document).ready(function () {
    let $slider = $('.js-slider');
    if ($slider.length > 0) {
        $slider.slick({
            arrows          : true,
            dots            : true,
            fade            : true,
            cssEase         : 'linear',
            speed           : 500,
            autoplaySpeed   : 7000,
            autoplay        : true,
            prevArrow       : '<button type="button" class="slick-prev slick-arrow" aria-label="Prev"><span class="next"></span></button>',
            nextArrow       : '<button type="button" class="slick-next slick-arrow" aria-label="Next"><span class="prev"></span></button>',
        });
    }
});

/*eslint-ensable */